// https://medium.com/codex/user-session-inactivity-timeout-with-rails-and-devise-7269ac3a8213
import $ from 'jquery';

let heartBeatActivated = false;
class HeartBeat {
  constructor() {
    document.addEventListener("DOMContentLoaded", () => {
      if ($("#user_logged_in").is(":visible") === true) {
        this.initHeartBeat();
      }
    });
  }

  initHeartBeat() {
    if (!heartBeatActivated) {
      heartBeatActivated = true;
    }
  }
}

window.heartBeat = new HeartBeat();

// pass in start time of timer (ms)
function inactivityPopup(start) {
  let timerInterval;

  Swal.fire({
    title: "Sessiosi on vanhentumassa",
    html:
      "Sinut kirjataan ulos <strong></strong> päästä.<br/><br/>" +
      "<button id='increase' class='button pointer'>" +
      "Olen vielä täällä!" +
      "</button><br/><br/>",
    timer: start,
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      const content = Swal.getHtmlContainer();
      if (!content) return;

      const increase = content.querySelector("#increase");

      if (increase) {
        increase.addEventListener("click", () => {
          sessionExtensionRequest(Swal);
        });
      }

      timerInterval = setInterval(() => {
        const container = Swal.getHtmlContainer();
        const strongElement = container ? container.querySelector('strong') : null;
        if (strongElement) {
          strongElement.textContent = secondsToMinutes(Swal.getTimerLeft() / 1000);
        }
      }, 100);
    },
    willClose: () => {
      clearInterval(timerInterval);
    },
  });
}

function secondsToMinutes(secondsToConvert) {
  return moment.utc(secondsToConvert * 1000).format("mm:ss");
}

function sessionExtensionRequest(swal) {
  let request = new XMLHttpRequest();
  request.open("GET", "/maintain_session", true);
  request.send();

  swal.close();
}

const sessionTimeoutPollFrequency = 600; // seconds
function pollForSessionTimeout() {
  let request = new XMLHttpRequest();
  request.onload = function (event) {
    var status = event.target.status;
    var response = event.target.response;

    // if the remaining valid time for the current user session is less than or equals to 0 seconds.
    if (status === 200 && (response <= 0)) {
      window.location.href = "/session_timeout";
    } else if (status === 200 && (response <= 600)) {
      inactivityPopup(response * 1000);
    }
  };

  request.open("GET", "/check_session_timeout", true);
  request.responseType = "json";
  request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  request.send();

  setTimeout(pollForSessionTimeout, (sessionTimeoutPollFrequency * 1000));
}

$(document).ready(function() {
  if ($("#user_logged_in").is(":visible") == true) {
    setTimeout(pollForSessionTimeout, (sessionTimeoutPollFrequency * 1000));
  }
});
